import { createSlice } from '@reduxjs/toolkit';
import { addNewStaffMember, createOptions, editStaffMember, getAllStaffMembers, getOptions } from './optionService';

const initialState = {
  options: {
    isLoading: null,
    isSuccess: null,
    options: null,
  },
  newOptions: {
    isOptionsCreating: null,
    isOptionsCreated: null,
    optionMsg: null,
  },
};

const optionSlice = createSlice({
  name: 'option',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getOptions.pending, (state) => {
        state.options = {
          ...initialState.options,
          isLoading: true,
        };
      })
      .addCase(getOptions.rejected, (state, action) => {
        state.options = {
          ...initialState.options,
          isLoading: false,
          isSuccess: action.payload || 'Error occurred while fetching options',
        };
      })
      .addCase(getOptions.fulfilled, (state, action) => {
        state.options = {
          ...initialState.options,
          isLoading: false,
          options: action.payload.data || [],
        };
      });

    //StaffMember creating
    builder
      .addCase(createOptions.pending, (state) => {
        state.newOptions = {
          ...initialState.newOptions,
          isOptionsCreating: true,
          optionMsg: 'Loading',
        };
      })
      .addCase(createOptions.rejected, (state, action) => {
        state.newOptions = {
          ...initialState.newOptions,
          isOptionsCreating: false,
          isOptionsCreated: false,
          optionMsg: action.payload || 'Error occurred while creating the options.',
        };
      })
      .addCase(createOptions.fulfilled, (state, action) => {
        state.newOptions = {
          ...initialState.newOptions,
          isOptionsCreating: false,
          isOptionsCreated: true,
          optionMsg: action.payload || 'Successfully created the options.',
        };
      });
  },
});

export default optionSlice.reducer;
